export default "__VITE_ASSET__DMgZx0uR__"